import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/HeaderReceptionist";
import { ReceptionSidebar } from "../Layouts/ReceptionSidebar";

export class Billing extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      paymentstype: "",
      procedurename: "",
      paymentsrefcode: "",
      paymentsamount: "",
      paymentspending: "",

      paymentsstatus: "pending",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    event.preventDefault();
    console.log(this.state);

    axios
      .post(this.api_url+"billing/new/paid", this.state, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  componentDidMount() {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    axios
      .get(this.url + "/chief/procedurecosts", { headers: headers })
      .then((res) => {
        const procedurecosts = res.data;
        console.log(procedurecosts);

        procedurecosts.forEach((cost) => {
          var option =
            "<option value=" +
            cost["procedurename"] +
            ">" +
            cost["procedurename"] +
            "</option>";
          $(".procedureNamePosition").append(option);
        });

        //   this.setState({ procedurecosts });
      });
    this.setState({
      visitBillingSerial: (Math.random() + 1).toString(36).substring(7),
      paymentspending: (Math.random() + 1).toString(36).substring(7),
      paymentspending: "default",
      paymentstime: "default",
      paymentsstatus: "default",
    });
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));
  }

  render() {
    const font16 = { fontSize: "20px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      paymentstype,
      procedurename,
      paymentsrefcode,
      paymentsamount,
      paymentspending,
      paymentdiscount,
    } = this.state;
    return (
      <div>
        <Headers />
        <ReceptionSidebar></ReceptionSidebar>
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row text-lg-center font-weight-bold p-1">
                <h4 className="text-capitalize " style={font16}>
                  Details
                </h4>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Payments Reference Code
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={paymentsrefcode}
                      name="paymentsrefcode"
                      type="text"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Payments Amount
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={paymentsamount}
                      name="paymentsamount"
                      type="text"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Payment Discount
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={paymentdiscount}
                      name="paymentdiscount"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Payment Type
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={paymentstype}
                      name="paymentstype"
                      required
                    >
                      <optgroup label="paymentstype">
                        <option selected></option>
                        <option value="cash">Cash</option>
                        <option value="cardPayment">CardPayment</option>
                      </optgroup>
                    </select>
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Procedure Name
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={procedurename}
                      name="procedurename"
                      required
                    >
                      <optgroup
                        label="procedurename"
                        className="procedureNamePosition"
                      >
                        <option selected></option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default Billing;
